// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"c8a90fd7","232":"5b0e099c","272":"dc1e6def","766":"0af38cc0","776":"76cb1211","800":"2f1e1004","969":"7834e00d"}[chunkId] + ".chunk.css";
};